import * as React from "react";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {ColorPopover} from "shared/controls/SingleInputs/SlateEditor/Buttons/ColorPopover";




export class ColorButton extends React.Component<ColorButtonProps, ColorButtonState> {
    static defaultProps: Partial<ColorButtonProps> = {
        Color:'',
        Disabled:false
    };
    public Container:HTMLDivElement;
    constructor(props: ColorButtonProps) {
        super(props);
        this.state = {
            displayColorPicker:false,
            Top:0
        };
    }


    public render() {
        let colorToUse=this.props.Color!=''?this.props.Color:`#000`;


        return (

            <div style={{display:'inline-block'}}>
                <div ref={x=>this.Container=x} style={ {padding: '5px', background: '#fff', borderRadius: '1px', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'block', cursor: 'pointer'} } onMouseDown={ (e)=>{e.preventDefault(); this.setState({displayColorPicker:!this.state.displayColorPicker&&!this.props.Disabled})} }>
                    <div style={{ width: '18px', height: '14px', borderRadius: '2px', background: colorToUse}} />
                    <ColorPopover ColorToUse={colorToUse} Container={this.Container} ColorChanged={x=>this.ColorSelected(x)} Visible={this.state.displayColorPicker} />
                </div>


            </div>
        )

    }

    private ColorSelected(color) {

        if(color!='') {
            ReactUtilities.ExecuteMethodPropIfDefined(this.props.ColorChanged,color);
            color='';
        }
        this.setState({displayColorPicker:false});
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ColorButtonProps {
    ColorChanged:(color:string)=>void;
    Color:string;
    Disabled:boolean;
}

interface ColorButtonState {
    displayColorPicker:boolean;
    Top:number;
}

//#endregion "My Region"